import { render, staticRenderFns } from "./rightControllerInsertion.vue?vue&type=template&id=4228fbfa&"
import script from "./rightControllerInsertion.vue?vue&type=script&lang=ts&"
export * from "./rightControllerInsertion.vue?vue&type=script&lang=ts&"
import style0 from "./rightControllerInsertion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports